import { render, staticRenderFns } from "./settingsForumTool.vue?vue&type=template&id=3bb253aa"
import script from "./settingsForumTool.vue?vue&type=script&lang=js"
export * from "./settingsForumTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports